import {
    put,
    takeEvery,
} from 'redux-saga/effects'

import {delay} from 'redux-saga/effects'

import {
    CREATE_TOAST,
    REMOVE_TOAST,
} from "app/types/api-types"

export function* handleToasts(action) {
    let timeout = action.payload?.ttl || 10
    yield delay(timeout * 1000)
    // api
    yield put({
        type: REMOVE_TOAST,
        payload: action.payload && action.payload.id
    })
}

export function* watchForToasts() {
    yield takeEvery(CREATE_TOAST, handleToasts)
}